export const featureFlags = {
  passwordLogin: true, // set to false to disable password login
};
